import { isDomainList, createSafeOriginUrl } from "./url";
const validDateRegExp = /^\d{4}-\d{1,2}-\d{1,2}$/;
export const isNumeric = (param) => typeof param === "number" && !Number.isNaN(param);
export const isEmpty = (param) => typeof param !== "string" || param.length === 0;
export const isNotEmpty = (param) => typeof param === "string" && param.length > 0;
export const isEmptyOrPositiveNumber = (param) => typeof param === "undefined" || (typeof param === "number" && param > 0);
export const isSafeUrl = (param) => {
    if (typeof param !== "string") {
        return false;
    }
    const url = createSafeOriginUrl(param);
    return typeof url === "string";
};
export const isValidDomainList = (param) => {
    if (!param) {
        return true;
    }
    if (typeof param !== "string") {
        return false;
    }
    return isDomainList(param);
};
export const isValidDate = (param) => {
    if (!param) {
        return false;
    }
    if (typeof param !== "string") {
        return false;
    }
    if (!validDateRegExp.test(param)) {
        return false;
    }
    if (!Date.parse(param)) {
        return false;
    }
    return true;
};
export function validateParams(command, paramDefinitions) {
    return paramDefinitions
        .map((definition) => {
        const name = String(definition.name);
        const param = command[name];
        return definition.validate(param, command.version)
            ? ""
            : `Invalid value for parameter "${name}", got "${String(param)}":`;
    })
        .filter((result) => result !== "");
}
